import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-20 pb-16 px-6 md:px-12 max-w-4xl mx-auto text-center" data-id="element-64">
      <FadeIn data-id="element-65">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-warm-dark leading-tight mb-6" data-id="element-66">
          Renacer en 7 Días:{' '}
          <span className="text-rose-gold block mt-2" data-id="element-67">
            El Código del Balance Hormonal
          </span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-68">
        <h2 className="text-lg md:text-xl text-warm-dark/80 font-sans max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-69">
          Recupera tu energía, apaga los sofocos y vuelve a tomar el control de
          tu cuerpo con el protocolo de nutrición botánica diseñado para la
          mujer de 45+.
        </h2>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-70">
        <button onClick={scrollToOffer} className="mb-12 inline-flex items-center bg-gradient-to-r from-rose-gold to-copper text-white font-bold font-sans text-lg py-4 px-10 rounded-full shadow-[0_0_20px_rgba(183,110,121,0.3)] hover:shadow-[0_0_30px_rgba(183,110,121,0.5)] hover:scale-[1.03] transition-all duration-300" data-id="element-71">
          ¡Quiero recuperar mi balance ahora!
        </button>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-72">
        <div className="relative mx-auto max-w-3xl" data-id="element-73">
          <div className="absolute inset-0 bg-copper/20 blur-2xl rounded-full transform -translate-y-4 scale-105" data-id="element-74"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5ffBJUNposow143FyX3wwJ/Renacer_en_7_dias_en_calma.png" alt="Renacer en 7 Días - El Código del Balance" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-white/50 object-cover" data-id="element-75" />
        </div>
      </FadeIn>
    </section>;
}